import React from 'react';
import axios from '../../../sharedModules/utils/axios.utils';
import { User } from '../../../homeModules/auth/model';
import { SelectOption } from '../../../sharedModules/form/model';

interface UserFormChoicesType {
  modules: SelectOption[];
}

interface UsersContextInterface {
  fetchUsers?: () => void;
  users?: User[];
  usersLoading?: boolean;

  fetchUser?: (user_id: string) => void;
  user?: User;
  userLoading?: boolean;

  userFormChoices?: UserFormChoicesType;

  formChoices?: SelectOption[];
  updateUser?: (user_id: string, formValues: FormData, onSucess: () => void) => void;
}

interface UsersContextProviderProps {
  children: React.ReactNode;
}

const UsersContext = React.createContext<UsersContextInterface>({});

const UsersContextConsumer = UsersContext.Consumer;
const UsersContextProvider: React.FC<UsersContextProviderProps> = ({ children }) => {
  const [users, setUsers] = React.useState<User[]>([]);
  const [usersLoading, setUsersLoading] = React.useState<boolean>(true);

  const [user, setUser] = React.useState<User>({});
  const [userLoading, setUserLoading] = React.useState<boolean>(true);

  const [userFormChoices, setUserFormChoices] = React.useState<UserFormChoicesType>();

  const [userSubmitting, setUserSubmitting] = React.useState<boolean>(false);

  const fetchUsers = async () => {
    const response = await axios.get<string, any>('/admin/users');

    setUsers(response?.data?.result);
    setUsersLoading(false);
  };

  const fetchUser = async (userId: string) => {
    const response = await axios.get<string, any>(`/admin/users/${userId}`);

    setUser(response?.data?.result);
    setUserLoading(false);
  };

  const updateUser = async (userId: string, formValues: FormData, onSucess: () => void) => {
    setUserSubmitting(true);

    await axios
      .put<any, any>(`/admin/users/${userId}`, formValues)
      .then((response) => {
        onSucess();
      })
      .catch((error) => {
        setUserSubmitting(false);
      });
  };

  return (
    <UsersContext.Provider
      value={{
        fetchUsers,
        users,
        usersLoading,

        fetchUser,
        user,
        userLoading,

        userFormChoices,
        updateUser,
      }}
    >
      {children}
    </UsersContext.Provider>
  );
};

export { UsersContextProvider, UsersContextConsumer, UsersContext };
